/**
 * Portrait HUD (GDD §7.2; frame 04): pause, score and fuel on the top row; level, section, jets (and LOW FUEL) chips
 * below; a thin progress bar; enemy-ability chips; the bridge-guns alert; touch controls at the bottom.
 */
import { config } from '../core/config.ts';
import { add, el } from './dom.ts';
import { abilityGroup, alertChip, bannerPart, iconButton, titleParts, touchControls, type HudRefs } from './parts.ts';

export function buildPortrait(doc: Document): HudRefs {
  const panels: HTMLElement[] = [];

  // Top row (frame 04).
  const row = el(doc, 'div', 'hw-prow');
  const menuBtn = add(row, iconButton(doc, 'pause', 'Pause'));
  const sc = add(row, el(doc, 'div', 'hw-pscore'));
  add(sc, el(doc, 'div', 'hw-pscore-label', 'SCORE'));
  const score = add(sc, el(doc, 'div', 'hw-pscore-value', '000 000'));
  const fuel = add(row, el(doc, 'div', 'hw-pfuel hw-glass'));
  const head = add(fuel, el(doc, 'div', 'hw-pfuel-head'));
  add(head, el(doc, 'span', '', 'FUEL'));
  const fuelPct = add(head, el(doc, 'span', 'hw-pfuel-pct', '100%'));
  const bar = add(fuel, el(doc, 'div', 'hw-pfuel-bar'));
  const fuelFill = add(bar, el(doc, 'div', 'hw-pfuel-fill'));
  fuelFill.style.width = '100%';
  add(bar, el(doc, 'div', 'hw-pfuel-seg'));
  panels.push(row);

  // Chips, progress, abilities and the alert.
  const col = el(doc, 'div', 'hw-pcol');
  const chips = add(col, el(doc, 'div', 'hw-pchips'));
  const level = add(chips, el(doc, 'span', 'hw-chip hw-amber', 'LEVEL 01'));
  const section = add(chips, el(doc, 'span', 'hw-chip', config.text.sections[0] ?? ''));
  const jetsText = add(chips, el(doc, 'span', 'hw-chip', 'JETS III'));
  const lowFuel = add(chips, el(doc, 'span', 'hw-chip hw-lowchip', 'LOW FUEL'));
  lowFuel.hidden = true;
  const pbar = add(col, el(doc, 'div', 'hw-pbar'));
  const progress = add(pbar, el(doc, 'div', 'hw-track-fill'));
  const ab = abilityGroup(doc, false);
  add(col, ab.box);
  const alert = add(col, alertChip(doc));
  panels.push(col);

  const t = titleParts(doc);
  const bn = bannerPart(doc);
  panels.push(t.title, t.press, t.credit, bn.wrap);

  const tc = touchControls(doc);

  return {
    panels,
    controls: [tc.pad, tc.fire, tc.autoFire],
    score,
    high: null,
    fuelBox: fuel,
    fuelPct,
    fuelFill,
    lowFuel,
    jetIcons: [],
    jetsText,
    level,
    section,
    sectionYields: true,
    bridgeFrom: null,
    bridgeTo: null,
    progress,
    abilities: ab.box,
    abilityChips: ab.chips,
    alert,
    bannerWrap: bn.wrap,
    banner: bn.banner,
    bannerHead: bn.head,
    bannerSub: bn.sub,
    bannerRows: bn.rows,
    bannerFinal: bn.final,
    bannerHigh: bn.high,
    bannerNew: bn.fresh,
    title: t.title,
    press: t.press,
    credit: t.credit,
    menuBtn,
    pauseBtn: null,
    settingsBtn: null,
    pad: tc.pad,
    thumb: tc.thumb,
    fire: tc.fire,
    fireBtn: tc.fireBtn,
    autoFire: tc.autoFire,
  };
}
